<div class="d-flex justify-content-center mt-5" style="width:100%; height:100%">
	<img src="/assets/tick.png" alt="" style="width:30%; height:auto" />
</div>
<div class="justify-content-center mt-3">
	<h3 class="text-center">Split Approved</h3>
</div>
